import React, { useState } from "react";
import Button from "../../components/Button/Button";
import { CustomerFileWrapper } from "./CustomerFileStyle";
import { AiFillDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { MdSystemUpdateAlt, MdCall, MdAccessTime } from "react-icons/md";
import { DeleteModal } from "../../components/Modals/DeleteModal/DeleteModal";
import { EditCustomerModal } from "../../components/Dialog/EditCustomerModal";
import { ChangeResponsibleModal } from "../../components/Dialog/ChangeResponsibleModal";
import { AddAddressModal } from "../../components/Dialog/AddAddressModal";
import { CrmTag } from "../../components/CrmTag/CrmTag";
import { BsPinMap } from "react-icons/bs";
import Typography from "../../components/Typography/Typography";
import { RiQuestionAnswerLine } from "react-icons/ri";
import { AiOutlinePlus } from "react-icons/ai";
import { AddActionModal } from "../../components/Dialog/AddActionModal";
import { DeleteActionModal } from "../../components/Dialog/DeleteActionModal";
import { DelayActionModal } from "../../components/Dialog/DelayActionModal";
import { EditActionModal } from "../../components/Dialog/EditActionModal";
import { SwitchingActionModal } from "../../components/Dialog/SwitchingActionModal";
import { QuickInvoiceModal } from "../../components/Dialog/QuickInvoiceModal";
import { Collapce } from "../../components/Collapce/Collapce";
import { CrmTab } from "../Crm/Components/CrmTab";
import { useParams } from "react-router-dom";
import { IoMdTrash } from "react-icons/io";
import {
  useCrmData,
  useGetNotes,
  useRestoreCustomer,
  useShowTag,
} from "../../hooks/useCrm";
import Loading from "../../components/Loadings/LoadingTable";
import { CgProfile } from "react-icons/cg";
import { DateDifference } from "../../utils/DateDIfference";
import Converter from "persian-date-converter";
import { NavLink } from "../../components/Navbar/navbarStyle";
import { DeleteNoteModal } from "../../components/Dialog/DeleteNoteModal";
import { EditNoteModal } from "../../components/Dialog/EditNoteModal";
import timeSetter from "../../utils/timeSetter";
import { RenderTooltip } from "../../components/Tooltip/Tooltip";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import { FaExchangeAlt } from "react-icons/fa";
import { AppStatusChangeModal } from "../../components/Dialog/AppStatusChangeModal";
import { MiladiToShamsi } from "../../utils/Miladi_To_Shamsi";
import { getTime } from "../../utils/getTime";
import MergeFilesModal from "../../components/Dialog/MergeFilesModal";
import { AnswerActionModal } from "../../components/Dialog/AnswerActionModal";
import { useEffect } from "react";
const initmodalvalue = {
  deletemodal: false,
  changeresponsible: false,
  editcustomer: false,
  addaddress: false,
  addaction: false,
  deleteaction: false,
  editaction: false,
  delayaction: false,
  switchingaction: false,
  // insertinvoice: false,
  quickinvoice: false,
  deletenote: false,
  editnote: false,
  appStatus: false,
  merge: false,
  answeraction: false,
};
export const CustomerFile = () => {
  const [show, setShow] = useState(initmodalvalue);
  const [activityId, setActivityId] = useState("");
  const [insertActionModal, setInsertActionModal] = useState(false);
  const { data: Tags } = useShowTag();
  const tags = Tags?.data?.tags;

  const [editActionData, setEditActionData] = useState();
  const [note, setNote] = useState();
  const { id } = useParams();
  const { data: crmdata, isLoading: crmDataLoading } = useCrmData({
    IdS0alesOpportunities: id,
  });
  const { data: Notes } = useGetNotes({ IdS0alesOpportunities: id });

  const { mutateAsync: RestoreCustomer } = useRestoreCustomer();
  useEffect(() => {
    if (insertActionModal) setShow({ ...initmodalvalue, addaction: true });
  }, [insertActionModal]);
  const data = crmdata?.data;
  const userinfo = data?.sales_opportunities[0];
  const _date = new Converter();
  const handleRestoreCustomer = async () => {
    await RestoreCustomer({ IdS0alesOpportunities: id });
  };

  var successfulPrice = data?.SumOrderOfline
    ? +data?.SumOrderOfline + +data?.Sumorder_onlines
    : 0 + +data?.Sumorder_onlines
    ? parseInt(data?.Sumorder_onlines)
    : 0;

  if (crmDataLoading) {
    return <Loading />;
  }

  return (
    <>
      {data?.sales_opportunities[0]?.DeleteFile === null ||
      !data?.sales_opportunities[0]?.DeleteFile.length ? (
        <CustomerFileWrapper>
          <BreadCrumb
            margin="mt-3"
            num1="واحد CRM"
            num2="پرونده مشتری"
            href1="/dashboard/crm"
          />
          <div className="row pt- poiu">
            <div className="col-xl-5 col-lg-12 col-12 col-md-12 col-sm-12 left-section">
              <div className="left-card">
                <div className="d-flex justify-content-between">
                  <Typography weight="bold" className="d-flex">
                    اطلاعات مشتری
                  </Typography>
                  <div className="buttons d-flex">
                    <RenderTooltip title="حذف پرونده">
                      <Button
                        bgColor="#f1416c"
                        color="#fff"
                        style={{ border: "none", marginRight: "7px" }}
                        small="fit-content"
                        onclick={() =>
                          setShow({ ...initmodalvalue, deletemodal: true })
                        }
                      >
                        <AiFillDelete />
                      </Button>
                    </RenderTooltip>
                    <RenderTooltip title="تغییر مسئول پرونده">
                      <Button
                        bgColor="#009ef7"
                        color="#fff"
                        small="fit-content"
                        style={{ border: "none", marginRight: "10px" }}
                        onclick={() =>
                          setShow({
                            ...initmodalvalue,
                            changeresponsible: true,
                          })
                        }
                      >
                        <MdSystemUpdateAlt />
                      </Button>
                    </RenderTooltip>
                    <RenderTooltip title="ویرایش پرونده">
                      <Button
                        bgColor="#50cd89"
                        color="#fff"
                        style={{ border: "none" }}
                        small="fit-content"
                        onclick={() =>
                          setShow({ ...initmodalvalue, editcustomer: true })
                        }
                      >
                        <FiEdit />
                      </Button>
                    </RenderTooltip>
                    <RenderTooltip title="وضعیت اپلیکیشن">
                      <Button
                        bgColor="#009ef7"
                        color="#fff"
                        small="fit-content"
                        style={{ border: "none", marginLeft: "10px" }}
                        onclick={() =>
                          setShow({
                            ...initmodalvalue,
                            appStatus: true,
                          })
                        }
                      >
                        <FaExchangeAlt />
                      </Button>
                    </RenderTooltip>
                  </div>
                </div>
                <div className="mt-2 w-100 d-flex">
                  <div className="img-side d-flex">
                    {userinfo?.Image ? (
                      <img
                        src={`https://apicrmtermeh.metanext.biz/thumbnail/Profile/${userinfo?.Image}`}
                        alt=""
                        style={{
                          width: "80px",
                          height: "80px",
                          borderRadius: "50%",
                        }}
                      />
                    ) : (
                      <CgProfile style={{ width: "60px", height: "60px" }} />
                    )}
                  </div>
                  <div className="m-2 mt-0 name-side">
                    <Typography size={"14px"}>
                      {userinfo?.FirstName} {userinfo?.LastName}
                    </Typography>
                    <Typography
                      size={"14px"}
                      className="mt-1"
                      style={{ fontSize: "14px" }}
                    >
                      {(
                        (userinfo?.OldPrice
                          ? parseInt(userinfo?.OldPrice)
                          : 0) + successfulPrice
                      ).toLocaleString()}
                    </Typography>
                    <Typography size={"14px"} className="mt-1">
                      سبک کار: {userinfo?.BrandCategory}
                    </Typography>
                    <Typography size={"14px"} className="mt-1">
                      دسته بندی: {userinfo?.NameCategory}
                    </Typography>
                    <Typography
                      hover={"cursor:pointer"}
                      size={"14px"}
                      className="mt-1"
                      onClick={() => {
                        navigator.clipboard.writeText(userinfo?.Phone);
                      }}
                    >
                      شماره تماس: 0{userinfo?.Phone}
                    </Typography>
                    <Typography size={"14px"} className="mt-1">
                      نحوه ثبت نام کاربر:{" "}
                      {data?.StatusAppAndRegistr[0]?.RegistrationStatus}
                    </Typography>
                    <Typography size={"14px"} className="mt-1">
                      اپلیکیشن دارد؟{" "}
                      {data?.StatusAppAndRegistr[0]?.StatusApplication}
                    </Typography>
                    <div className="flex">
                      <Typography
                        size={"14px"}
                        className={`mt-1 cursor-pointer`}
                        primary="#2FA0F7"
                      >
                        {data?.merge_file}{" "}
                      </Typography>
                      {data?.merge_file === "پرونده زیر مجموعه ای ندارد" ? (
                        <Typography
                          size={"14px"}
                          className={`mt-1 mr-1 cursor-pointer underline`}
                          onClick={() => setShow({ ...show, merge: true })}
                        >
                          افزودن
                        </Typography>
                      ) : (
                        <Typography
                          size={"14px"}
                          className={`mt-1 mr-1 cursor-pointer underline`}
                          onClick={() => setShow({ ...show, merge: true })}
                        >
                          مشاهده
                        </Typography>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-1 w-100">
                  <div className="responsible d-flex flex-fill">
                    <div className="img-fluid">
                      <img
                        src={`https://apicrmtermeh.metanext.biz/thumbnail/Profile/${data?.ResponsibleUser[0]?.Image}`}
                        alt=""
                        style={{
                          borderRadius: "50%",
                          border: "1px solid #d5d5d5",
                          width: "40px",
                          height: "40px",
                        }}
                      />
                    </div>
                    <div className="m-2 mb-2 d-flex align-items-center">
                      <Typography>
                        {data?.ResponsibleUser[0]?.FirstName}{" "}
                        {data?.ResponsibleUser[0]?.LastName}
                      </Typography>
                    </div>
                  </div>
                  <div className="p-2 pt-0 pb-0 row justify-content-end">
                    <CrmTag
                      tagname={
                        userinfo?.methodOfIntroduction
                          ? userinfo?.methodOfIntroduction
                          : "بدون انتخاب"
                      }
                      bgColor="#009ef7"
                    />
                    <CrmTag
                      tagname={userinfo?.RankingCustomer}
                      bgColor="#f1416c"
                    />
                    <CrmTag tagname={userinfo?.NameCities} bgColor="#50cd89" />
                    <CrmTag
                      tagname={userinfo?.KindCustomer}
                      bgColor="#009ef7"
                    />
                    <CrmTag tagname={userinfo?.KindSeller} bgColor="#f1416c" />
                    <CrmTag
                      tagname={userinfo?.ProbabilityOfPurchase}
                      bgColor="#50cd89"
                    />
                    <CrmTag
                      tagname={
                        data?.MarketerUser[0]?.IdUser === 38
                          ? "بدون بازاریاب"
                          : data?.MarketerUser[0]?.FirstName
                          ? data?.MarketerUser[0]?.FirstName +
                            " " +
                            data?.MarketerUser[0]?.LastName
                          : "بدون بازاریاب"
                      }
                      bgColor="#009ef7"
                    />
                  </div>
                </div>
              </div>
              <div className="mt-4 left-card">
                <div className="buttons w-100 d-flex justify-content-between">
                  <RenderTooltip title="افزودن آدرس">
                    <Button
                      bgColor="#50cd89"
                      color="#fff"
                      style={{ border: "none" }}
                      small="fit-content"
                      onclick={() =>
                        setShow({ ...initmodalvalue, addaddress: true })
                      }
                      className=""
                    >
                      <FiEdit />
                    </Button>
                  </RenderTooltip>
                  <Typography weight="bold" className="d-flex align-items-end">
                    اطلاعات تماس
                  </Typography>
                </div>
                <div className="mt-2 row">
                  <div className="col-6 col-lg-8 col-md-8">
                    {data?.addresses?.map((address, index) => (
                      <div className="d-flex" key={index}>
                        <div className="img-side d-flex">
                          <BsPinMap />
                        </div>
                        <div className="m-2 mt-0 name-side flex-fill">
                          <Typography>
                            {address?.NameProvinces}, {address?.NameCities},{" "}
                            {address?.Address}
                          </Typography>
                        </div>
                      </div>
                    ))}
                  </div>
                  <div className="col-6 col-lg-4 col-md-4 d-flex justify-content-end">
                    <Typography
                      onClick={() => {
                        navigator.clipboard.writeText(userinfo?.Phone);
                      }}
                      hover={"cursor:pointer"}
                    >
                      0{data?.sales_opportunities[0].Phone} <MdCall />
                    </Typography>
                  </div>
                </div>
                <div className="mt-3 w-100">
                  <Typography weight="bold">شماره های بیشتر</Typography>
                  <Typography className="mt-2" weight="light">
                    {userinfo?.PhoneTwo
                      ? userinfo?.PhoneTwo
                      : "شماره بیشتری وجود ندارد"}
                  </Typography>
                </div>
                <div className="mt-3 w-100">
                  <Typography weight="bold">توضیحات</Typography>
                  <Typography className="mt-2" weight="light">
                    {userinfo?.Description
                      ? userinfo?.Description
                      : "توشیحاتی وجود ندارد"}
                  </Typography>
                </div>
              </div>
              <div className="mt-4 left-card">
                <div className="buttons w-100 d-flex justify-content-between">
                  <RenderTooltip title="افزودن فعالیت">
                    <Button
                      bgColor="#50cd89"
                      color="#fff"
                      style={{ border: "none" }}
                      small="fit-content"
                      onclick={() =>
                        setShow({ ...initmodalvalue, addaction: true })
                      }
                    >
                      <AiOutlinePlus />
                    </Button>
                  </RenderTooltip>
                  <Typography
                    weight="bold"
                    className="d-flex align-items-center"
                  >
                    فعالیت های برنامه ریزی شده
                  </Typography>
                </div>
                {data?.activity_crms?.map((activity, index) => {
                  const rawDate = activity.DateReferenceActivityCrm;

                  const createDate = activity.created_at;
                  var year = createDate.slice(0, 4);
                  var month = createDate.slice(5, 7);
                  var day = createDate.slice(8, 10);
                  var date = year + "-" + month + "-" + day;
                  var dateWrapper = _date.convert(date, "fa");
                  var slicedDate;
                  if (rawDate.length > 10) {
                    slicedDate = rawDate.slice(0, 10);
                  }
                  const Date = slicedDate.replace(/-/g, "/");
                  var diff = DateDifference(Date);

                  return (
                    <div
                      className="p-1 m-0 mt-2 mb-2 border rounded row"
                      key={index}
                    >
                      <div className="p-0 pt-2 m-0 text-center col-lg-1 col-md-3 col-2">
                        <img
                          src={`https://apicrmtermeh.metanext.biz/thumbnail/Profile/${activity.Image}`}
                          alt=""
                          style={{
                            borderRadius: "50%",
                            border: "1px solid #d5d5d5",
                            width: "40px",
                            height: "40px",
                          }}
                          className="img-fluid"
                        />
                        <Typography size="10px" className="mt-1">
                          {activity.FirstName} {activity.LastName}
                        </Typography>
                      </div>
                      <div className="p-1 pt-0 pb-0 d-block col-lg-8 col-md-9 col-10">
                        {activity.StatusImportant === "important" ? (
                          <>
                            <Typography
                              size="14px"
                              weight="bold"
                              primary="#f1416c"
                              className="mt-2 text-wrap"
                            >
                              {activity.SubjectActivityCrm}
                            </Typography>
                          </>
                        ) : (
                          <>
                            <Typography
                              size="14px"
                              weight="bold"
                              className="mt-2 text-wrap"
                            >
                              {activity.SubjectActivityCrm}
                            </Typography>
                          </>
                        )}
                        <Typography size="14px" className="mt-1 text-break">
                          {activity.DescriptionActivityCrm}
                        </Typography>
                        <Typography size="14px" className="text-wrap d-flex">
                          {diff === 0
                            ? "امروز"
                            : diff < 0
                            ? -diff + " " + "روز رد شده"
                            : diff + " " + "روز مانده"}{" "}
                          {"(" +
                            timeSetter(activity.created_at) +
                            " " +
                            dateWrapper +
                            ")"}
                        </Typography>
                      </div>

                      <div className="flex-wrap p-0 pb-2 d-flex col-lg-3 col-md-12 col-12 justify-content-center justify-content-md-end align-content-start">
                        <RenderTooltip title="پاسخ فعالیت">
                          <Button
                            bgColor="#009EF7"
                            color="#fff"
                            style={{
                              border: "none",
                              marginRight: "5px",
                              padding: "7px",
                              height: "35px",
                            }}
                            small="fit-content"
                            onclick={() => {
                              setShow({
                                ...initmodalvalue,
                                answeraction: true,
                              });
                              setActivityId(activity.IdActivityCrm);
                            }}
                          >
                            <RiQuestionAnswerLine />
                          </Button>
                        </RenderTooltip>
                        <RenderTooltip title="به تاخیر انداختن">
                          <Button
                            bgColor="#f1416c"
                            color="#fff"
                            style={{
                              border: "none",
                              marginRight: "5px",
                              padding: "7px",
                              height: "35px",
                            }}
                            small="fit-content"
                            onclick={() => {
                              setShow({
                                ...initmodalvalue,
                                delayaction: true,
                              });
                              setActivityId(activity.IdActivityCrm);
                            }}
                          >
                            <MdAccessTime />
                          </Button>
                        </RenderTooltip>
                        <RenderTooltip title="تغییر وضعیت">
                          <Button
                            bgColor="#009ef7"
                            color="#fff"
                            small="fit-content"
                            style={{
                              border: "none",
                              marginRight: "5px",
                              padding: "7px",
                              height: "35px",
                            }}
                            onclick={() => {
                              setShow({
                                ...initmodalvalue,
                                switchingaction: true,
                              });
                              setActivityId(activity.IdActivityCrm);
                            }}
                          >
                            <MdSystemUpdateAlt />
                          </Button>
                        </RenderTooltip>
                        <RenderTooltip title="ویرایش فعالیت">
                          <Button
                            bgColor="#50cd89"
                            color="#fff"
                            style={{
                              border: "none",
                              marginRight: "5px",
                              padding: "7px",
                              height: "35px",
                            }}
                            small="fit-content"
                            onclick={() => {
                              setShow({ ...initmodalvalue, editaction: true });
                              setEditActionData(activity);
                            }}
                          >
                            <FiEdit />
                          </Button>
                        </RenderTooltip>
                        <RenderTooltip title="حذف فعالیت">
                          <Button
                            bgColor="#f1416c"
                            color="#fff"
                            style={{
                              border: "none",
                              marginRight: "5px",
                              padding: "7px",
                              height: "35px",
                            }}
                            small="fit-content"
                            onclick={() => {
                              setShow({
                                ...initmodalvalue,
                                deleteaction: true,
                              });
                              setActivityId(activity.IdActivityCrm);
                            }}
                          >
                            <AiFillDelete />
                          </Button>
                        </RenderTooltip>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="mt-4 left-card">
                <div className="buttons w-100 d-flex justify-content-between">
                  <div>
                    <Button
                      bgColor="#009ef7"
                      color="#fff"
                      style={{ border: "none", marginRight: "5px" }}
                      small="fit-content"
                    >
                      <NavLink
                        to={"/dashboard/accounting/orders/invoice"}
                        drop="12px"
                      >
                        پیش فاکتور
                      </NavLink>
                    </Button>
                    <Button
                      bgColor="#f1416c"
                      color="#fff"
                      style={{
                        border: "none",
                        marginRight: "5px",
                      }}
                      small="fit-content"
                      onclick={() =>
                        setShow({ ...initmodalvalue, quickinvoice: true })
                      }
                      size="12px"
                    >
                      <NavLink to={""}>فاکتور سریع</NavLink>
                    </Button>
                  </div>
                  <Typography
                    weight="bold"
                    className="d-flex align-items-center"
                  >
                    معاملات جاری
                  </Typography>
                </div>

                <div className="mt-2 text-center d-flex justify-content-center">
                  <div className="successful">
                    <Typography>
                      {successfulPrice ? successfulPrice.toLocaleString() : 0}
                    </Typography>
                    <Typography>
                      {parseInt(data?.Numberorder_offlines) +
                        parseInt(data?.Numberorder_onlines)}{" "}
                      معامله موفق
                    </Typography>
                  </div>
                  <div className="unsuccessful">
                    <Typography>
                      {data?.Sumorder_offlines_unsuccessfuls
                        ? parseInt(
                            data?.Sumorder_offlines_unsuccessfuls
                          ).toLocaleString()
                        : 0}
                    </Typography>
                    <Typography>
                      {data?.Numberorder_offlines_unsuccessfuls} معامله ناموفق
                    </Typography>
                  </div>
                </div>
              </div>
              <div className="mt-4 left-card">
                <div className="">
                  <Typography
                    weight="bold"
                    className="d-flex align-items-center"
                  >
                    فعالیت در اپلیکیشن
                  </Typography>
                </div>
                <div className="mt-2 row">
                  {data?.log?.map((item, index) => {
                    return (
                      <div className="items-center mb-3 col-6 d-flex">
                        {index + 1}-{" "}
                        <Typography className="mr-1">
                          زمان ورود : {MiladiToShamsi(item.created_at)} ورژن
                          اپلیکیشن : {item.Build}
                        </Typography>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="mt-3 col-xl-7 col-lg-12 right-section mt-lg-0">
              <Collapce
                closebutton={true}
                title={`لیست یادداشت ها (${Notes?.data?.note_for_crms?.length})`}
                button={true}
                hasModal={true}
                payload={data}
              >
                {Notes?.data?.note_for_crms?.map((note) => (
                  <div className="m-0 mt-1 row align-items-center">
                    <div className="p-0 mb-2 col-lg-1 col-md-2 col-1 d-flex justify-content-center">
                      <img
                        src={`https://apicrmtermeh.metanext.biz//thumbnail/Profile/${note.Image}`}
                        className="rounded-circle img-fluid w-50"
                        alt=""
                      />
                    </div>
                    <div className="col-lg-9 col-md-8 col-8">
                      <Typography size="14px" className="text-break">
                        {note.FirstName} {note.LastName} :{" "}
                        {note.DescriptionNote}
                      </Typography>
                    </div>
                    <div className="col-lg-2 col-md-2 col-3 justify-content-end d-flex align-self-baseline ">
                      <RenderTooltip title="حذف یادداشت">
                        <Button
                          bgColor="#f1416c"
                          small="30px"
                          className="p-1"
                          onclick={() => {
                            setNote(note);
                            setShow({ ...show, deletenote: true });
                          }}
                        >
                          <IoMdTrash color="#fff" />
                        </Button>
                      </RenderTooltip>
                      <RenderTooltip title="ویرایش یادداشت">
                        <Button
                          bgColor="#009ef7"
                          small="30px"
                          className="p-1 mx-2"
                          onclick={() => {
                            setNote(note);
                            setShow({ ...show, editnote: true });
                          }}
                        >
                          <FiEdit color="#fff" />
                        </Button>
                      </RenderTooltip>
                    </div>
                  </div>
                ))}
              </Collapce>
              <div className="w-100">
                <CrmTab userdata={data} tags={tags ? tags : ""} />
              </div>
            </div>
          </div>
          <DeleteModal
            handleClose={() =>
              setShow({ ...initmodalvalue, deletemodal: false })
            }
            show={show.deletemodal}
          />
          <ChangeResponsibleModal
            handleClose={() =>
              setShow({ ...initmodalvalue, changeresponsible: false })
            }
            show={show.changeresponsible}
            idSalesOpportunities={userinfo?.IdS0alesOpportunities}
            userdata={data}
          />
          <EditCustomerModal
            handleClose={() =>
              setShow({ ...initmodalvalue, editcustomer: false })
            }
            show={show.editcustomer}
            userdata={data}
          />
          <AddAddressModal
            handleClose={() =>
              setShow({ ...initmodalvalue, addaddress: false })
            }
            show={show.addaddress}
            userdata={data}
          />
          <AddActionModal
            handleClose={() => setShow({ ...initmodalvalue, addaction: false })}
            show={show.addaction}
            userdata={data}
          />
          <DeleteActionModal
            handleClose={() =>
              setShow({ ...initmodalvalue, deleteaction: false })
            }
            show={show.deleteaction}
            userdata={data}
            activityId={activityId}
          />
          <DelayActionModal
            handleClose={() =>
              setShow({ ...initmodalvalue, delayaction: false })
            }
            show={show.delayaction}
            userdata={data}
            activityId={activityId}
          />
          <EditActionModal
            handleClose={() =>
              setShow({ ...initmodalvalue, editaction: false })
            }
            show={show.editaction}
            userdata={data}
            editActionData={editActionData}
          />
          <SwitchingActionModal
            handleClose={() =>
              setShow({ ...initmodalvalue, switchingaction: false })
            }
            show={show.switchingaction}
            activityId={activityId}
          />
          <QuickInvoiceModal
            handleClose={() =>
              setShow({ ...initmodalvalue, quickinvoice: false })
            }
            show={show.quickinvoice}
          />
          {/* <InsertInvoiceModal
            handleClose={() =>
              setShow({ ...initmodalvalue, insertinvoice: false })
            }
            show={show.insertinvoice}
          /> */}
          <DeleteNoteModal
            handleClose={() => setShow({ ...show, deletenote: false })}
            show={show.deletenote}
            note={note}
          />
          <EditNoteModal
            handleClose={() => setShow({ ...show, editnote: false })}
            show={show.editnote}
            note={note}
          />
          <AppStatusChangeModal
            handleClose={() => setShow({ ...show, appStatus: false })}
            show={show.appStatus}
            id={id}
          />
          <MergeFilesModal
            show={show.merge}
            handleClose={() => setShow({ ...show, merge: false })}
            id={id}
          />
          <AnswerActionModal
            handleClose={() =>
              setShow({ ...initmodalvalue, answeraction: false })
            }
            show={show.answeraction}
            userdata={data}
            activityId={activityId}
            setInsertActionModal={setInsertActionModal}
          />
        </CustomerFileWrapper>
      ) : (
        <>
          <div className="mt-5 d-flex justify-content-center">
            <Typography>
              {" "}
              {data?.sales_opportunities[0]?.DeleteFile}{" "}
            </Typography>
          </div>
          <div className="d-flex justify-content-center">
            <Button
              onclick={handleRestoreCustomer}
              bgColor="#0d6efd"
              color="#fff"
              small="150px"
            >
              فعال کردن پرونده
            </Button>
          </div>
        </>
      )}
    </>
  );
};
